export default theme => ({
    root: {
        padding: theme.spacing(-1),
        //Custom Styles AP
        backgroundColor: '#525252',
    },
    button: {
        padding: theme.spacing(0),
        //Custom Styles AP
        backgroundColor: '#DDDDDD',
    },
    item: {
        height: '100%',
        [theme.breakpoints.down('lg')]: {
            width: '100%',
        }
    },
    itemGauge: {
        height: '100%',
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    modal: {
        backgroundColor: 'white',
        border: '2px solid #000',
        width: '60vw',
        [theme.breakpoints.between('sm', 'lg')]: {
            width: '60vw',
        },
        [theme.breakpoints.down('sm')]: {
            width: '75vw',
        },
    },
    paper: {
        backgroundColor: 'white',
        border: '2px solid #000',
        width: '75vw',
        borderBottom: "1px solid #e4dede",
        [theme.breakpoints.up('xs')]: {
            width: '75vw',
        },
        [theme.breakpoints.down('sm')]: {
            width: '100vw',
        },
    },
});